import { getDbSupabase } from './supabase';

export type CitSocSyncResult = {
  ok: boolean;
  error?: string;
  year_prefix?: string;
  powerbi_lines?: number;
  soc_docs?: number;
  inserted?: number;
  updated?: number;
  skipped_locked?: number;
  skipped_empty?: number;
  actor?: string;
  duration_ms?: number;
  synced_at?: string;
};

/** Manual / on-demand sync: PowerBI 2026 SOC quotes → CIT. */
export async function runCitSocSyncFromPowerBi(): Promise<CitSocSyncResult> {
  const { data, error } = await getDbSupabase().functions.invoke('cit-soc-sync-from-powerbi', {
    body: {},
  });
  if (error) {
    throw new Error(error.message || 'CIT SOC sync failed.');
  }
  const result = (data ?? {}) as CitSocSyncResult;
  if (!result.ok) {
    throw new Error(result.error || 'CIT SOC sync failed.');
  }
  return result;
}
